import { render, staticRenderFns } from "./taskpre.vue?vue&type=template&id=f80dc3b8"
import script from "./taskpre.vue?vue&type=script&lang=js"
export * from "./taskpre.vue?vue&type=script&lang=js"
import style0 from "./taskpre.vue?vue&type=style&index=0&id=f80dc3b8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f80dc3b8')) {
      api.createRecord('f80dc3b8', component.options)
    } else {
      api.reload('f80dc3b8', component.options)
    }
    module.hot.accept("./taskpre.vue?vue&type=template&id=f80dc3b8", function () {
      api.rerender('f80dc3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/taskpre.vue"
export default component.exports